import React from "react"
import cx from "classnames"

type Props = {
  className?: string
  height?: number
  width?: number
  fill: string
  isSelected?: boolean
}

function Hamburger({ className, height, width, fill, isSelected }: Props) {
  return (
    <svg
      className={cx(className)}
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27 36"
    >
      <rect
        fill={fill}
        width="27"
        height="3"
        rx="1.5"
        className={cx("transform origin-center", { "rotate-45": isSelected })}
        x="0"
        y={isSelected ? "12.5" : "9"}
      ></rect>

      <rect
        fill={fill}
        className={cx({ "opacity-0": isSelected })}
        y="16.5"
        width="27"
        height="3"
        rx="1.5"
      ></rect>

      <rect
        fill={fill}
        width="27"
        height="3"
        rx="1.5"
        className={cx("transform origin-center", { "-rotate-45": isSelected })}
        x={isSelected ? "4" : "0"}
        y={isSelected ? "17" : "24"}
      ></rect>
    </svg>
  )
}

export default Hamburger
